<template>
    <ais-instant-search
        :search-client="searchClient"
        index-name="pages"
        class="HeaderSearch"
    >
        <ais-configure :hits-per-page.camel="6" />

        <ais-state-results>
            <template v-slot="{ state: { query } }">
                {{ activateSearch(query) }}
            </template>
        </ais-state-results>

        <ais-search-box>
            <template v-slot="{ currentRefinement, refine }">
                <div class="HeaderSearchBox flex-center-b">
                    <input
                        type="search"
                        placeholder="Search the website"
                        :value="currentRefinement"
                        @input="debounceRefine(refine, $event.currentTarget.value)"
                        @keyup.enter="redirectToSearch"
                    >

                    <a :href="searchUrl">
                        <BaseIcon icon="search-icon" />
                    </a>
                </div>
            </template>
        </ais-search-box>

        <HeaderSearchResults v-show="isActive" :searchUrl="searchUrl"/>
    </ais-instant-search>
</template>
<script>
import algoliasearch from 'algoliasearch/lite';
import { debounce } from 'lodash';
import { initReciteMe } from '../scripts/reciteme';

const algoliaClient = algoliasearch(
    window.algoliaId,
    window.algoliaSearchKey
);

const searchClient = {
    ...algoliaClient,
    search(requests) {
        if (requests.every(({ params }) => !params.query)) {
            return Promise.resolve({
                results: requests.map(() => ({
                    hits: [],
                    nbHits: 0,
                    nbPages: 0,
                    page: 0,
                    processingTimeMS: 0,
                    hitsPerPage: 0,
                    exhaustiveNbHits: false,
                    query: '',
                    params: '',
                })),
            });
        }

        return algoliaClient.search(requests);
    },
};

export default {
    name: 'HeaderSearch',

    data() {
        return {
            searchClient,
            isActive: false,
            searchUrl: '/search'
        }
    },

    methods: {
        activateSearch(q) {
            const queryLength = !!q.length;
            this.isActive = queryLength;
            this.searchUrl = queryLength ? `/search?query=${q}` : '/search';
            document.querySelector('body').classList.toggle('has-overlay', queryLength);
        },

        redirectToSearch() {
            window.location = this.searchUrl;
        },

        debounceRefine: debounce(function (refine, value) {
            window.dataLayer.push({
                event: "header_search_results_update",
                search_keyword: value
            });

            refine(value);
        }, 400)
    },

    mounted() {
      initReciteMe({
        insertDesktopButton: (btn) => {
          const parent = document.querySelector('.HeaderSearch');
          if (parent) parent.appendChild(btn);
        }
      });
    }
}
</script>

<style lang="scss">

    .HeaderSearch {
        display: flex;
        align-items: center;
        justify-content: between;
        .ais-SearchBox {
            background-color: rgba(255,255,255,.3);
            border-radius: 8px;
            padding: 0 15px
        }
    }


    .DefaultHeader .ais-InstantSearch,
    .TransparentHeader .ais-InstantSearch {
        @include media-query(reciteme) {
            display: none;
        }
    }

    .HeaderSearch--is-transparent {
        color: #fff;

        .HeaderSearchBox input {
            background: transparent;
            color: #fff;

            &::placeholder {
                color: rgba(255, 255, 255, 0.7);
            }
        }

        .TransparentHeader.is-fixed &,
        body.flyout-is-active & {
            color: $base-font-color;
            .HeaderSearchBox input {
                background: transparent;
                color: $base-font-color;

                &::placeholder {
                    color: $base-font-color;
                }
            }
        }
    }

    .HeaderSearchBox input {
        padding: 0.5rem 0;
        border: 0;
        font-size: 1rem;
        color: $base-font-color;
        font-family: $base-font-family;
        font-size: 0.8rem;
        width: 150px;
    }

</style>
